import { inject, Injectable } from '@angular/core';
import { ACTIVATION_SERVICE } from '@features/auth/activation.service.interface';
import { lastValueFrom } from 'rxjs';
import { LEERKR8_API_SERVICE } from './leerkr8/leerkr8-api.service.interface';

export type PlayerProfile = {
  nickname: string;
  playerCode: string;
};

@Injectable({
  providedIn: 'root',
})
export class PlayerGroupManagerService {
  private leerkr8Api = inject(LEERKR8_API_SERVICE);
  private activationService = inject(ACTIVATION_SERVICE);

  async getProfiles(playerGroupCode: string): Promise<PlayerProfile[]> {
    const activationData = this.activationService.getActivationData();

    if (activationData === null) {
      throw new Error('No activation data found');
    }

    const playerGroup = await lastValueFrom(
      this.leerkr8Api.getPlayerGroup(activationData.token, activationData.deviceIdentifier, playerGroupCode),
    );

    return playerGroup.playerCodes.map((playerCode) => {
      const index = playerGroup.playerCodes.indexOf(playerCode);

      return {
        nickname: playerGroup.playerSaves[index].nickname,
        playerCode,
      };
    });
  }
}
